/* eslint-disable */
import { produce } from "immer";
import {
  FETCH_REFRESH_TOKEN_START,
  FETCH_REFRESH_TOKEN_SUCCESS,
  FETCH_REFRESH_TOKEN_FAILURE,
} from "../actions/types";

const refreshToken = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_REFRESH_TOKEN_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FETCH_REFRESH_TOKEN_SUCCESS:
      return produce(state, (draft) => {
        draft.data = true;
        draft.fetching = false;
      });
    case FETCH_REFRESH_TOKEN_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default refreshToken;
